import { render, staticRenderFns } from "./CStatsRow.vue?vue&type=template&id=d3bae5e0&scoped=true&"
import script from "./CStatsRow.vue?vue&type=script&lang=js&"
export * from "./CStatsRow.vue?vue&type=script&lang=js&"
import style0 from "./CStatsRow.vue?vue&type=style&index=0&id=d3bae5e0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3bae5e0",
  null
  
)

export default component.exports